import React from 'react';

import { connect } from 'react-redux';

import { css } from 'glamor';

import { ZINDEX_OVERLAY_BG } from 'depop/styles/zIndex';

import FixedPage from 'react-fixed-page';

import { closeAll } from 'depop/state/navigation';

const OverlayBackground = ({ isOpen, closeAll }) =>
  <div
    {...css({
      position: 'fixed',
      zIndex: ZINDEX_OVERLAY_BG,
      top: 0,
      right: 0,
      pointerEvents: isOpen ? 'auto' : 'none',
      left: 0,
      bottom: -100,
      content: '""',
      transition: 'opacity 0.2s ease-in-out',
      opacity: isOpen ? 1 : 0,
      background: 'rgba(0, 0, 0, .4)',
    })}
    onClick={isOpen && closeAll}>
    {' '}<FixedPage fixed={isOpen} />
  </div>;

const mapStateToProps = ({ navigation }) => ({
  isOpen: navigation.isSearchOpen || navigation.isMobileNavOpen,
});

const mapDispatchToProps = dispatch => {
  return {
    closeAll: () => dispatch(closeAll()),
  };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(OverlayBackground);



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/OverlayBackground.js